import { useState, useEffect } from 'react';

export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg';

export interface BreakpointState {
  bp: Breakpoint;
  isMobile: boolean;    // xs | sm
  isTablet: boolean;    // sm | md
  isDesktop: boolean;   // lg
  width: number;
}

function getBreakpoint(width: number): Breakpoint {
  if (width < 480) return 'xs';
  if (width < 768) return 'sm';
  if (width < 1024) return 'md';
  return 'lg';
}

export function useBreakpoint(): BreakpointState {
  const [width, setWidth] = useState(() => window.innerWidth);

  useEffect(() => {
    const handler = () => setWidth(window.innerWidth);
    const observer = new ResizeObserver(handler);
    observer.observe(document.documentElement);
    return () => observer.disconnect();
  }, []);

  const bp = getBreakpoint(width);
  return {
    bp,
    isMobile: bp === 'xs' || bp === 'sm',
    isTablet: bp === 'sm' || bp === 'md',
    isDesktop: bp === 'lg',
    width,
  };
}
